import { Component, Input, TemplateRef } from '@angular/core';
import { EoViewComponentDescriptor, EoViewComponentTypeEnum, EoViewPanelConfig, SeverityEnum } from 'ngx-eo-web-components';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-view-panel',
  templateUrl: './view-panel.component.html',
  styleUrl: './view-panel.component.scss'
})
export class ViewPanelComponent<T> {
  @Input() items!: BehaviorSubject<T>;
  @Input() labels: { [key: string]: string } = {};
  @Input() eoViewComponents: EoViewComponentDescriptor[] = [];
  @Input() headerTemplate?: TemplateRef<any>;
  @Input() keys: string[] = [];
  @Input() id!: string;
  @Input() componentTypes: { [key: string]: EoViewComponentTypeEnum } = {};
  @Input() statusSeverityMap: { [key: string]: string } = {
    Draft: SeverityEnum.Info,
    Cancelled: SeverityEnum.Danger,
    Denied: SeverityEnum.Danger,
    ReturnedByEkapy: SeverityEnum.Warning,
    Submitted: SeverityEnum.Warning,
    PendingBoard: SeverityEnum.Warning,
    ApprovedByBoard: SeverityEnum.Success,
    Approved: SeverityEnum.Success,
    PendingConsultation: SeverityEnum.Info,
    PendingFromCommittee: SeverityEnum.Warning,
  };

  @Input() config: EoViewPanelConfig = {};
  @Input() materialRequestCategory?: any;


  constructor(
    //private cd: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.items.subscribe((items) => {
      this.setKeys(items);
      this.config.viewComponents = this.generateViewComponents(items, this.keys);
      this.config.viewComponents = this.addViewComponents(this.config.viewComponents, this.eoViewComponents);
    });
  }

  private setKeys(items?: T): void {
    // Start with the existing keys
    let additionalKeys: string[] = [];

    // Only add extra keys if this panel is for 'requestDetails'
    if (this.id === 'requestDetails' && items) {
      const statusAlias = (items as any).statusAlias;

      // If status is 'Denied', add 'denyComments' and, if SupplierRequest, also add 'supplierRequestDenyReasonDescription'
      if (statusAlias === 'Denied') {
        additionalKeys.push('denyComments');
      }
    }

    if (this.id === 'apiCredentialsDetails' && items) {
      const username = (items as any).username;
      const password = (items as any).password;
      const clientSecret = (items as any).clientSecret;

      const hasCredentials = username !== null && password !== null && clientSecret !== null;

      if (hasCredentials) {
        additionalKeys.push('username', 'password', 'clientSecret');
      }
    }

    this.keys = Array.from(new Set([...this.keys, ...additionalKeys]));
  }

  generateViewComponents(items: T, keys: string[]): EoViewComponentDescriptor[] {
    if (!keys || !items) return [];

    return keys
      .filter((key) => items[key as keyof T] !== undefined)
      .map((key) => ({
        componentType: this.getComponentTypeForKey(key, items),
        label: this.getLabelForKey(key),
        severity: this.setSeverity((items as any).statusAlias ?? null),
        value: items[key as keyof T],
      }));
  }

  setSeverity(statusAlias: string | null): string {
    if (!statusAlias) return '';
    return this.statusSeverityMap[statusAlias] || 'secondary';
  }

  getComponentTypeForKey(key: string, items: T): EoViewComponentTypeEnum {
    const componentType = this.componentTypes[key];
    if (componentType === EoViewComponentTypeEnum.DATE && items[key as keyof T] === '-') {
      return EoViewComponentTypeEnum.TEXT;
    }

    return this.componentTypes[key] || EoViewComponentTypeEnum.TEXT;
  }

  getLabelForKey(key: string): string {
    return this.labels[key] || key;
  }

  addViewComponents(viewComponents: EoViewComponentDescriptor[], newComponents: EoViewComponentDescriptor[]): EoViewComponentDescriptor[] {
    return [...viewComponents, ...newComponents];
  }
}
